var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTravel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 60 60",
    style: {
      enableBackground: "new 0 0 60 60"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#007DC3;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M21.7,53.2c-0.3,0-0.6-0.1-0.9-0.2c-0.6-0.3-1-1-1-1.6v-4c0-0.5,0.2-1,0.6-1.4l5-4.5l-0.7-9.4L7.3,40.4 c-0.6,0.3-1.3,0.2-1.8-0.1c-0.5-0.3-0.9-0.9-0.9-1.6l0-2.1c0-2.5,0.6-3,10.3-11.3c2.4-2.1,5.4-4.6,9.1-7.8 c0.3-3.9,0.8-10.7,5.9-10.7c5.2,0,5.7,7.2,5.9,10.7c3.8,3.2,6.8,5.8,9.2,7.9c9.7,8.3,10.3,8.8,10.3,11.3v2.1 c0,0.6-0.3,1.2-0.9,1.6c-0.5,0.3-1.2,0.4-1.8,0.1l-17.5-8.2l-0.7,9.4l5,4.5c0.4,0.4,0.6,0.9,0.6,1.4l0,3.9c0,0.7-0.4,1.3-1,1.6 c-0.6,0.3-1.3,0.3-1.9,0l-7.7-4.6l-6.9,4.6C22.4,53.1,22,53.2,21.7,53.2z M29.6,44.3c0.3,0,0.7,0.1,1,0.3l5.2,3.1l-4.4-4 c-0.4-0.4-0.7-0.9-0.6-1.5l1-13.1c0-0.6,0.4-1.2,0.9-1.5c0.5-0.3,1.2-0.3,1.7-0.1l16.4,7.7c-1.1-1.1-3.4-3.1-8.1-7.1 c-2.5-2.2-5.7-4.9-9.8-8.4c-0.4-0.3-0.6-0.8-0.7-1.3l0-0.7c-0.1-1.8-0.5-7.3-2.2-7.3c-1.7,0-2.1,5.4-2.2,7.4l0,0.6 c0,0.5-0.3,1-0.6,1.3c-4,3.5-7.2,6.2-9.7,8.4c-4.6,4-7,6-8.1,7.1l16.3-7.7c0.6-0.3,1.2-0.2,1.7,0.1c0.5,0.3,0.9,0.9,0.9,1.5 l1,13.1c0,0.6-0.2,1.1-0.6,1.5L25,46.9l3.5-2.3C28.8,44.4,29.2,44.3,29.6,44.3z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTravel);
export default __webpack_public_path__ + "static/media/travel.77e0f28c46b3f6b7277808272f52bb60.svg";
export { ForwardRef as ReactComponent };